<template lang="html">
  <!-- <input type="tel"
         :value="formattedValue"
         @change="change"
         v-money="{precision, decimal, thousands, prefix, suffix}"
         class="v-money" /> -->
  <div class="prefix input-group input-group--text-field input-group--prefix primary--text" ref="divvmoney">
	  <label>{{label}}</label>
	  <div class="input-group__input">
      <span class="input-group--text-field__prefix">R$</span>
		  <input 
        tabindex="0" 
        :aria-label="label" type="tel"
        :value="formattedValue"
        @change="change"
        @focus="onFocusApplyDirtClass"
        @blur="applyClasseDirtAndFocus"
        v-money="{precision, decimal, thousands, prefix, suffix}"
        :required="validation"
        ref="inputvmoney"/>
	  </div>
    <div class="input-group__details" >
      <div class="input-group__messages input-group__error" v-if="errorMessage">
        Insira um valor
      </div>
    </div>
  </div>
  <!-- <v-text-field
    :label="label"    
    prefix="R$"  
    :value="formattedValue"
    class="prefix v-money"
    @change="change"
    v-money="{precision, decimal, thousands, prefix, suffix}"
    :rules="rulesProp"
    >
  </v-text-field> -->
</template>

<script>
import money from './directive'
import defaults from './options'
import {format, unformat} from './utils'

export default {
  name: 'Money',
  props: {
    validation: {
      required: false,
      defaults: false
    },
    label: {
      required: false,
      default: 'Valor Final'
    },
    rulesProp: {
      required: false
    },
    value: {
      required: true,
      default: 0
    },
    masked: {
      type: Boolean,
      default: false
    },
    precision: {
      type: Number,
      default: () => defaults.precision
    },
    decimal: {
      type: String,
      default: () => defaults.decimal
    },
    thousands: {
      type: String,
      default: () => defaults.thousands
    },
    prefix: {
      type: String,
      default: () => defaults.prefix
    },
    suffix: {
      type: String,
      default: () => defaults.suffix
    }
  },
  directives: {money},
  data () {
    return {
      formattedValue: '',
      formatted: '',
      errorMessage: false,
      erroClasses: [
        'input-group--error',
        'error--text'
      ]
    }
  },
  watch: {
    value: {
      immediate: true,
      handler (newValue, oldValue) {
        if (newValue && newValue !== '') {
          this.formatted = format(newValue, this.$props)
        } else {
          if (this.$props.validation) {
            this.formatted = '0'
          } else {
            this.formatted = ''
          }
        }

        if (this.formatted !== this.formattedValue) {
          this.formattedValue = this.formatted
          this.formatted = ''
        }
      }
    }
  },
  methods: {
    change (evt) {
      this.$emit('input', this.masked ? evt.target.value : ((!evt.target.value) ? '' : unformat(evt.target.value, this.precision)))
      // this.$emit('input', this.masked ? evt : ((!evt) ? '' : unformat(evt, this.precision)))
    },
    applyClasseDirtAndFocus () {
      if (typeof this.$refs.divvmoney !== 'undefined') {
        if (this.$refs.divvmoney.classList.contains('input-group--focused')) {
          this.$refs.divvmoney.classList.remove('input-group--focused')
        }
        if (typeof this.$refs.inputvmoney !== 'undefined') {
          if (this.$refs.inputvmoney.value.length === 0) {
            if (this.$refs.divvmoney.classList.contains('input-group--dirty')) {
              this.$refs.divvmoney.classList.remove('input-group--dirty')
            }
          } else {
            this.$refs.divvmoney.classList.add('input-group--dirty')
          }
        }
        this.validationInput()
      }
    },
    onFocusApplyDirtClass () {
      if (this.validationRefDivMoney) {
        this.$refs.divvmoney.classList.add('input-group--focused')
        if (!this.$refs.divvmoney.classList.contains('input-group--dirty')) {
          this.$refs.divvmoney.classList.add('input-group--dirty')
        }
      }
    },
    validationInput () {
      if (this.$props.validation && this.validationFieldInputMoney && this.validationRefDivMoney) {
        this.erroClasses.forEach(element => {
          this.$refs.divvmoney.classList.add(element)
        })
        this.errorMessage = true
      } else {
        this.errorMessage = false
        this.erroClasses.forEach(element => {
          if (this.$refs.divvmoney.classList.contains(element)) {
            this.$refs.divvmoney.classList.remove(element)
          }
        })
      }
    },
    appllyRequiredClass () {
      if (this.validationRefDivMoney && this.$props.validation) {
        this.$refs.divvmoney.classList.add('input-group--required')
      }
    },
    setValueDefaultForRequiredFields () {
      if (this.$props.validation) {
        this.$props.formattedValue = 0
      }
    }
  },
  computed: {
    validationRefDivMoney () {
      return typeof this.$refs.divvmoney !== 'undefined'
    },
    validationFieldInputMoney () {
      if (typeof this.$refs.inputvmoney !== 'undefined') {
        return this.$refs.inputvmoney.value.length === 0
      } else {
        return false
      }
    }
  },
  mounted () {
    this.setValueDefaultForRequiredFields()
    this.applyClasseDirtAndFocus()
    this.appllyRequiredClass()
  },
  updated () {
    this.applyClasseDirtAndFocus()
  }
}
</script>



// WEBPACK FOOTER //
// component.vue?640d55f2